import { configureStore } from '@reduxjs/toolkit';
import realmReducer from './realm-app';
import appReducer from './app';
import scoreReducer, { scoreActions } from './score';
import undoable, { includeAction } from 'redux-undo';

//These are the only actions that should trigger undo/redo.
const includeActions = [scoreActions.toggleAccent, scoreActions.toggleFlam, scoreActions.toggleDiddle,
                       scoreActions.toggleCheese, scoreActions.toggleLeftSticking, scoreActions.toggleRightSticking,
                       scoreActions.addMeasure, scoreActions.deleteMeasure, scoreActions.modifyNote,
                       scoreActions.updateScore, scoreActions.togglePartEnabled, scoreActions.deletePart, 
                       scoreActions.addPart, scoreActions.mutateNotes, scoreActions.updateTimeSig, scoreActions.clearScore,
                       scoreActions.adjustMeasures, scoreActions.pasteMeasure, scoreActions.replaceMeasure, scoreActions.replaceMeasures,
                       scoreActions.addTreeBranches, scoreActions.selectTreeBranch, scoreActions.renameTreeBranch, scoreActions.deleteTreeBranch,
                       scoreActions.setKeySignature, scoreActions.pianoWrite, scoreActions.pianoTranspose, scoreActions.pianoRest,
                       scoreActions.setDynamic, scoreActions.clearDynamics, scoreActions.toggleHairpin, scoreActions.setMeasureMarking,
                       scoreActions.addTakes, scoreActions.showTake, scoreActions.setTakeRule, scoreActions.removeTake,
                       scoreActions.addEnsemble, scoreActions.movePart, scoreActions.renamePart, scoreActions.showOnlyPart, scoreActions.showAllParts,
                       scoreActions.toggleConcertPitch, scoreActions.toggleTie, scoreActions.toggleSlur, scoreActions.setNoteText, scoreActions.toggleArticulation,
                       scoreActions.setLyric, scoreActions.chooseVoice
                    ].map(action => action.type);

const store = configureStore({
    reducer: {
        realm: realmReducer,
        app: appReducer,
        score: undoable(scoreReducer, { 
            filter: includeAction(includeActions)
        })
    }
})

export default store;
